module.exports = __webpack_public_path__ + "img/quality.99f5c94d.jpg";